import { render } from "./EventItemFull.vue?vue&type=template&id=6b178e22&ts=true"
import script from "./EventItemFull.vue?vue&type=script&lang=ts"
export * from "./EventItemFull.vue?vue&type=script&lang=ts"

import "./EventItemFull.vue?vue&type=style&index=0&id=6b178e22&lang=stylus"
import "./EventItemFull.vue?vue&type=style&index=1&id=6b178e22&lang=css"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__